import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";
import { initializeCreatorData } from "@/data/data";


if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}

void initializeCreatorData().finally(() => {
  import("./main.app.ui").then(({ initUI }) => {
    initUI();
  });
});

emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    void initApp();
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://e0aeb8f80cfc8b91bd72dbcee65926a3@o1388406.ingest.us.sentry.io/4511256264966144",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}